export const defaultStructure = {
  type: 'doc',
  attrs: {
    id: null,
    lp_name: '',
    deletable: true,
    appliedThemeId: null,
    pageId: null,
    backgroundColor: 'inherit',
    data: {},
  },
  content: [
    {
      type: 'container',
      attrs: {
        id: '20489355-c46f-4992-a3de-5b799eeb268d',
        lp_name: 'Recommendation',
        deletable: true,
        tokens: {
          backgroundColor: 'background_color',
        },
        mergeTag: null,
        textAlign: 'center',
        width: '100%',
        stackOnMobile: true,
        borderRadius: '24px 24px 24px 24px',
        appliedThemeId: null,
        position: 'relative',
        top: '0px',
        left: '0px',
        right: '0px',
        bottom: '0px',
        positionTopActive: true,
        positionLeftActive: false,
        positionRightActive: true,
        positionBottomActive: false,
        centerHorizontally: false,
        centerVertically: false,
        flexDirection: 'row',
        mobileFlexDirection: 'row',
        backgroundColor: '#030712',
        overflow: 'hidden',
        shadow: 'none',
        blur: '0px',
        backgroundDarken: false,
        horizontalAlign: 'left',
        verticalAlign: 'align_start',
        width_max: '100%',
        mobilePadding: '24px 24px 24px 24px',
        padding: '22px 22px 22px 22px',
        margin: '0px 0px 0px 0px',
        gap: '12px',
        borderWidth: '1px',
        borderColor: '#E5E7EB',
        borderStyle: 'solid',
        flexWrap: 'nowrap',
        zIndex: 'auto',
      },
      content: [
        {
          type: 'container',
          attrs: {
            id: '6b81eba7-8e57-42ee-b61c-39b5046f7c76',
            lp_name: 'Content',
            deletable: true,
            tokens: {},
            mergeTag: null,
            textAlign: 'center',
            width: '100%',
            stackOnMobile: true,
            borderRadius: '0px 0px 0px 0px',
            appliedThemeId: null,
            position: 'relative',
            top: '0px',
            left: '0px',
            right: '0px',
            bottom: '0px',
            positionTopActive: true,
            positionLeftActive: false,
            positionRightActive: true,
            positionBottomActive: false,
            centerHorizontally: false,
            centerVertically: false,
            flexDirection: 'row',
            mobileFlexDirection: 'column',
            backgroundColor: '#03071200',
            overflow: 'visible',
            shadow: 'none',
            blur: '0px',
            backgroundDarken: false,
            horizontalAlign: 'left',
            verticalAlign: 'align_start',
            width_max: '100%',
            mobilePadding: '0px 0px 0px 0px',
            padding: '0px 0px 0px 0px',
            margin: '0px 0px 0px 0px',
            gap: '12px',
            borderWidth: '1px',
            borderColor: '#E5E7EB',
            borderStyle: 'none',
            flexWrap: 'nowrap',
            zIndex: 'auto',
          },
          content: [
            {
              type: 'container',
              attrs: {
                id: '335daa92-3bcf-49d0-b22f-766e89b55797',
                lp_name: 'Logo',
                deletable: true,
                tokens: {},
                mergeTag: null,
                textAlign: 'center',
                width: 'auto',
                stackOnMobile: true,
                borderRadius: '0px 0px 0px 0px',
                appliedThemeId: null,
                position: 'relative',
                top: '0px',
                left: '0px',
                right: '0px',
                bottom: '0px',
                positionTopActive: true,
                positionLeftActive: false,
                positionRightActive: true,
                positionBottomActive: false,
                centerHorizontally: false,
                centerVertically: false,
                flexDirection: 'column',
                mobileFlexDirection: 'column',
                backgroundColor: '#03071200',
                overflow: 'visible',
                shadow: 'none',
                blur: '0px',
                backgroundDarken: false,
                horizontalAlign: 'left',
                verticalAlign: 'align_start',
                width_max: null,
                mobilePadding: '0px 0px 0px 0px',
                padding: '0px 0px 0px 0px',
                margin: '0px 0px 0px 0px',
                gap: '4px',
                borderWidth: '1px',
                borderColor: '#E5E7EB',
                borderStyle: 'none',
                flexWrap: 'nowrap',
                zIndex: 'auto',
              },
              content: [
                {
                  type: 'image',
                  attrs: {
                    id: '9106eda7-4daa-4f18-ab10-fcd3c735e778',
                    lp_name: 'Logo',
                    tokens: {},
                    mergeTag: 'recommendation.image',
                    width: '52px',
                    boxShadow: 'none',
                    appliedThemeId: null,
                    position: 'relative',
                    top: '0px',
                    left: '0px',
                    right: '0px',
                    bottom: '0px',
                    positionTopActive: true,
                    positionLeftActive: false,
                    positionRightActive: true,
                    positionBottomActive: false,
                    centerHorizontally: false,
                    centerVertically: false,
                    url: '',
                    open_in_new_tab: false,
                    internal_link: false,
                    padding: '0px',
                    target: null,
                    captionUrl: '',
                    captionTarget: null,
                    src: 'https://beehiiv-images-production.s3.us-east-1.amazonaws.com/dream_builder/publications/Market+Maven.jpg',
                    title: '',
                    alt: 'Market Maven',
                    align: 'center',
                    captionAlign: 'center',
                    borderWidth: '0px',
                    objectFit: 'cover',
                    aspectRatio: 1,
                    borderRadius: '6px 6px 6px 6px',
                    borderColor: '#E5E7EB',
                    borderStyle: 'none',
                    isFullWidth: false,
                  },
                },
              ],
            },
            {
              type: 'container',
              attrs: {
                id: '73c67f68-7e2f-4754-a926-bc277bbd2834',
                lp_name: 'Info',
                deletable: true,
                tokens: {},
                mergeTag: null,
                textAlign: 'center',
                width: '100%',
                stackOnMobile: true,
                borderRadius: '0px 0px 0px 0px',
                appliedThemeId: null,
                position: 'relative',
                top: '0px',
                left: '0px',
                right: '0px',
                bottom: '0px',
                positionTopActive: true,
                positionLeftActive: false,
                positionRightActive: true,
                positionBottomActive: false,
                centerHorizontally: false,
                centerVertically: false,
                flexDirection: 'column',
                mobileFlexDirection: 'column',
                backgroundColor: '#03071200',
                overflow: 'visible',
                shadow: 'none',
                blur: '0px',
                backgroundDarken: false,
                horizontalAlign: 'left',
                verticalAlign: 'align_start',
                width_max: '100%',
                mobilePadding: '0px 0px 0px 0px',
                padding: '0px 0px 0px 0px',
                margin: '0px 0px 0px 0px',
                gap: '4px',
                borderWidth: '1px',
                borderColor: '#E5E7EB',
                borderStyle: 'none',
                flexWrap: 'nowrap',
                zIndex: 'auto',
              },
              content: [
                {
                  type: 'container',
                  attrs: {
                    id: 'fd2c7dc3-e1ff-491d-ad0a-4303b936dbea',
                    lp_name: '',
                    deletable: true,
                    tokens: {},
                    mergeTag: null,
                    textAlign: 'center',
                    width: '100%',
                    stackOnMobile: true,
                    borderRadius: '0px 0px 0px 0px',
                    appliedThemeId: null,
                    position: 'relative',
                    top: '0px',
                    left: '0px',
                    right: '0px',
                    bottom: '0px',
                    positionTopActive: true,
                    positionLeftActive: false,
                    positionRightActive: true,
                    positionBottomActive: false,
                    centerHorizontally: false,
                    centerVertically: false,
                    flexDirection: 'column',
                    mobileFlexDirection: 'column',
                    backgroundColor: '#03071200',
                    overflow: 'visible',
                    shadow: 'none',
                    blur: '0px',
                    backgroundDarken: false,
                    horizontalAlign: 'left',
                    verticalAlign: 'align_start',
                    width_max: '100%',
                    mobilePadding: '0px 0px 0px 0px',
                    padding: '0px 0px 0px 0px',
                    margin: '0px 0px 0px 0px',
                    gap: '16px',
                    borderWidth: '1px',
                    borderColor: '#E5E7EB',
                    borderStyle: 'none',
                    flexWrap: 'nowrap',
                    zIndex: 'auto',
                  },
                  content: [
                    {
                      type: 'paragraph',
                      attrs: {
                        id: 'a1c37dcf-1f2c-4481-bd71-4e292ceed2f9',
                        lp_name: 'Sponsored',
                        deletable: true,
                        textAlign: 'left',
                        tokens: {},
                        mergeTag: 'recommendation.sponsored',
                        width: '100%',
                        maxWidth: '100%',
                        appliedThemeId: null,
                        backgroundColor: 'transparent',
                        borderRadius: '0px',
                        borderWidth: '0px',
                        borderColor: 'inherit',
                        borderStyle: 'none',
                        lineClampClass: '',
                        padding: '0px 0px 0px 0px',
                        mobilePadding: '0px 0px 0px 0px',
                        lineHeight: '120%',
                        mobileLineHeight: '120%',
                        margin: null,
                        postAuthors: [],
                        postAuthorsTruncateListEnabled: false,
                        postAuthorsImagesEnabled: true,
                        postAuthorsTextEnabled: true,
                        postAuthorsImagesFill: 'inherit',
                        postAuthorsByLine: '',
                        postTimestampDisplay: 'short_date',
                        postReadTimeSuffix: 'min read',
                        postTagsTruncateListEnabled: true,
                        postTagsGap: '4px',
                        postPaidContentGap: '4px',
                        postPaidContentIconSize: 16,
                        postPaidIconFill: '#030712',
                        postPaidText: '',
                        postAuthorsGap: '4px',
                        postAuthorsImageSize: '24px',
                        textTransform: 'none',
                      },
                      content: [
                        {
                          type: 'text',
                          marks: [
                            {
                              type: 'textStyle',
                              attrs: {
                                mobileFontSize: '12px',
                                fontSize: '12px',
                                fontWeight: '400',
                                fontGradient: null,
                                fontFamily: 'Inter',
                                color: '#FFFFFF',
                                textTransform: null,
                                tokens: {
                                  color: 'text_on_background_color',
                                },
                                appliedThemeId: null,
                                hoverTextColor: null,
                                hoverDecorationLine: null,
                                hoverDecorationColor: null,
                              },
                            },
                          ],
                          text: 'Sponsored',
                        },
                      ],
                    },
                    {
                      type: 'container',
                      attrs: {
                        id: 'f15e1d08-a261-4442-840d-4bfee6ccf927',
                        lp_name: '',
                        deletable: true,
                        tokens: {},
                        mergeTag: null,
                        textAlign: 'center',
                        width: '100%',
                        stackOnMobile: true,
                        borderRadius: '0px 0px 0px 0px',
                        appliedThemeId: null,
                        position: 'relative',
                        top: '0px',
                        left: '0px',
                        right: '0px',
                        bottom: '0px',
                        positionTopActive: true,
                        positionLeftActive: false,
                        positionRightActive: true,
                        positionBottomActive: false,
                        centerHorizontally: false,
                        centerVertically: false,
                        flexDirection: 'column',
                        mobileFlexDirection: 'column',
                        backgroundColor: '#03071200',
                        overflow: 'visible',
                        shadow: 'none',
                        blur: '0px',
                        backgroundDarken: false,
                        horizontalAlign: 'left',
                        verticalAlign: 'align_start',
                        width_max: '100%',
                        mobilePadding: '0px 0px 0px 0px',
                        padding: '0px 0px 0px 0px',
                        margin: '0px 0px 0px 0px',
                        gap: '10px',
                        borderWidth: '1px',
                        borderColor: '#E5E7EB',
                        borderStyle: 'none',
                        flexWrap: 'nowrap',
                        zIndex: 'auto',
                      },
                      content: [
                        {
                          type: 'heading',
                          attrs: {
                            id: '07d5b554-5bbd-47d4-a323-78661022564c',
                            lp_name: 'Name',
                            deletable: true,
                            textAlign: 'left',
                            tokens: {},
                            mergeTag: 'recommendation.name',
                            width: '100%',
                            maxWidth: '100%',
                            appliedThemeId: null,
                            level: 1,
                            lineClampClass: '',
                            backgroundColor: '#030712',
                            borderRadius: '0px',
                            borderWidth: '0px',
                            borderColor: 'inherit',
                            borderStyle: 'none',
                            lineHeight: '37%',
                            mobileLineHeight: '50%',
                            padding: '0px 0px 0px 0px',
                            mobilePadding: '0px 0px 0px 0px',
                            textTransform: 'none',
                          },
                          content: [
                            {
                              type: 'text',
                              marks: [
                                {
                                  type: 'textStyle',
                                  attrs: {
                                    mobileFontSize: '20px',
                                    fontSize: '20px',
                                    fontWeight: '500',
                                    fontGradient: null,
                                    fontFamily: 'Inter',
                                    color: '#FFFFFF',
                                    textTransform: null,
                                    tokens: {
                                      color: 'text_on_background_color',
                                    },
                                    appliedThemeId: null,
                                    hoverTextColor: null,
                                    hoverDecorationLine: null,
                                    hoverDecorationColor: null,
                                  },
                                },
                              ],
                              text: 'Market Maven',
                            },
                          ],
                        },
                        {
                          type: 'paragraph',
                          attrs: {
                            id: 'abcaba43-2290-479a-969d-80b1399930c1',
                            lp_name: 'Description',
                            deletable: true,
                            textAlign: 'left',
                            tokens: {},
                            mergeTag: 'recommendation.description',
                            width: '100%',
                            maxWidth: '100%',
                            appliedThemeId: null,
                            backgroundColor: '#030712',
                            borderRadius: '0px',
                            borderWidth: '0px',
                            borderColor: 'inherit',
                            borderStyle: 'none',
                            lineClampClass: '',
                            padding: '0px 0px 0px 0px',
                            mobilePadding: '0px 0px 0px 0px',
                            lineHeight: '120%',
                            mobileLineHeight: '120%',
                            margin: null,
                            postAuthors: [],
                            postAuthorsTruncateListEnabled: false,
                            postAuthorsImagesEnabled: true,
                            postAuthorsTextEnabled: true,
                            postAuthorsImagesFill: 'inherit',
                            postAuthorsByLine: '',
                            postTimestampDisplay: 'short_date',
                            postReadTimeSuffix: 'min read',
                            postTagsTruncateListEnabled: true,
                            postTagsGap: '4px',
                            postPaidContentGap: '4px',
                            postPaidContentIconSize: 16,
                            postPaidIconFill: '#030712',
                            postPaidText: '',
                            postAuthorsGap: '4px',
                            postAuthorsImageSize: '24px',
                            textTransform: 'none',
                          },
                          content: [
                            {
                              type: 'text',
                              marks: [
                                {
                                  type: 'textStyle',
                                  attrs: {
                                    mobileFontSize: '16px',
                                    fontSize: '16px',
                                    fontWeight: '400',
                                    fontGradient: null,
                                    fontFamily: 'Inter',
                                    color: '#FFFFFF',
                                    textTransform: null,
                                    tokens: {
                                      color: 'text_on_background_color',
                                    },
                                    appliedThemeId: null,
                                    hoverTextColor: null,
                                    hoverDecorationLine: null,
                                    hoverDecorationColor: null,
                                  },
                                },
                              ],
                              text: 'A daily newsletter that provides deep insights into market trends, financial strategies, and emerging investment opportunities.',
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          type: 'container',
          attrs: {
            id: '30373611-874a-4431-b752-34c792693b65',
            lp_name: '',
            deletable: true,
            tokens: {},
            mergeTag: null,
            textAlign: 'center',
            width: 'auto',
            stackOnMobile: true,
            borderRadius: '0px 0px 0px 0px',
            appliedThemeId: null,
            position: 'relative',
            top: '0px',
            left: '0px',
            right: '0px',
            bottom: '0px',
            positionTopActive: true,
            positionLeftActive: false,
            positionRightActive: true,
            positionBottomActive: false,
            centerHorizontally: false,
            centerVertically: false,
            flexDirection: 'column',
            mobileFlexDirection: 'row',
            backgroundColor: '#03071200',
            overflow: 'visible',
            shadow: 'none',
            blur: '0px',
            backgroundDarken: false,
            horizontalAlign: 'right',
            verticalAlign: 'align_start',
            width_max: null,
            mobilePadding: '0px 0px 0px 0px',
            padding: '0px 0px 0px 0px',
            margin: '0px 0px 0px 0px',
            gap: '4px',
            borderWidth: '1px',
            borderColor: '#E5E7EB',
            borderStyle: 'none',
            flexWrap: 'nowrap',
            zIndex: 'auto',
          },
          content: [
            {
              type: 'switch',
              attrs: {
                id: '07b74d62-408b-4552-9399-0cecb1068e18',
                lp_name: '',
                tokens: {
                  backgroundColor: 'border_color',
                  backgroundColorSelect: 'primary_color',
                  thumbColor: 'background_color',
                },
                mergeTag: 'recommendation.switch',
                appliedThemeId: null,
                mobileWidth: '100%',
                mobileMaxWidth: '100%',
                width: '100%',
                maxWidth: '100%',
                mobile_hide: false,
                desktop_hide: false,
                customAttributes: '',
                backgroundColor: '#E5E7EB',
                backgroundColorSelect: '#FFFFFF',
                thumbColor: '#030712',
                padding: '0px 0px 0px 0px',
              },
            },
          ],
        },
      ],
    },
  ],
};
